<template>
  <div style="    background: rgb(249, 250, 254);">
    <nav_list></nav_list>

    <div class="per">

      <div class="t1 bdall">
        <div class="tit1">

          {{ $lang(42340) }}

        </div>
        <div class="img1">
          <img :src="thumb ? thumb : '~@/../../static/image/cover1.png'">
        </div>
        <div class="train">
          <span class="tit2">{{ $lang(42341) }} </span>
          <div class="con1"  v-if="put.source == 'bushikaku'">
            <span>{{tt(vo.service_name)}} </span>
          </div>
          <div class="con1"  v-else>
            <span>{{tt(vo.line)}} - {{tt(vo.sn)}} </span>
          </div>
        </div>

        <div class="txt1" v-if="0">
          <div class="text1">
            <span>{{ $lang(42376)}} </span><br>
            <span v-html="refund_plan"> </span>
          </div>
        </div>
      </div>

      <div class="t2">
        <div class="step1">
          <div class="con1">
            <img src="~@/../static/image/ok.png">
            <div class="y1">
              <span class="u1">{{ $lang(42342) }}</span><br>
              <span class="u2">{{ $lang(42343) }}</span>
            </div>
          </div>
          <div class="con1">
            <img src="~@/../static/image/step2.png">
            <div class="y1">
              <span class="u1">{{ $lang(42344) }}</span><br>
              <span class="u2">{{ $lang(42345) }}</span>
            </div>
          </div>
          <div class="con1">
            <img src="~@/../static/image/step3.png">
            <div class="y1">
              <span class="u1">{{ $lang(42346) }}</span><br>
              <span class="u2">{{ $lang(42347) }}</span>
            </div>
          </div>
        </div>

        <div class="channel">
         
          <div style="margin-left: 2%;"  v-if="put.source == 'bushikaku'">
            <span>{{tt(vo.service_name)}} </span>
          </div>
          <div style="margin-left: 2%;" v-else>
            {{tt(vo.line)}} - {{tt(vo.sn)}}
          </div>

          <div class="screen" v-if="put.source != 'bushikaku'" >

            <div class="block1 trtagzz" v-for="(src, j) in vo.icon" :key="j">


              <img class="incoimg"   :src="src" />

            </div>



          </div>
          <div class="lef btf_soll">



            <div class="ponts"  v-if="put.source == 'bushikaku'" >

          
                  <div class="bl " v-for="(pt, n) in vo.platforms.filter(p => p.platform_type === 'geton')"  :key="pt.name"
                    @click="show_point(pt)">
                    {{ tt(pt.name) }} <br>
                    {{ pt.time }}
                  </div>
                  <div class="bl yel "v-for="(pt, n) in vo.platforms.filter(p => p.platform_type === 'getout')"  :key="pt.name"
                    @click="show_point(pt)">
                    {{ tt(pt.name) }}
                    <br>
                    {{ pt.time }}
                  </div>
        
            </div>
              <div class="ponts"  v-else >

              <div class="bl " v-for="(pt, n) in vo.starts" :key="n" >
                {{ tt(pt.title) }}
                <br>
                {{ pt.time }}
              </div>
              <div class="bl yel " v-for="(pt, n) in  vo.ends" :key="n"
                >
                {{ tt(pt.title) }}
                <br>
                {{ pt.time }}

              </div>
            </div>

          </div>
        </div>

        <div class="sele1">
          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42348) }}</span>
            </div>
            <div class="ipt1">

              {{ put.date }}

            </div>
          </div>
          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42349) }}</span>
            </div>
            <div class="ipt1 pt_box">

               <template v-if="put.source == 'highwaybus'">
						<div class="pre_city">

							<div class="tlt">
									{{get_start_tit()}}
							</div>
							<div class="icr">

							</div>

						</div>
					</template>
           <template v-if="put.source == 'jbus'">
 <el-select class="ipt" v-model="put.start_point_id" @change="start_change">
                <el-option v-for="(pt, n) in starts" :key="n" :label="pt.tit"
                  :value="pt.id">
                </el-option>
              </el-select>
           </template>
           <template v-if="put.source == 'bushikaku'">
 <el-select class="ipt" v-model="put.start_point_i" >
                <el-option v-for="(pt, n) in start_points" :key="n" :label="pt.title"
                  :value="n">
                </el-option>
              </el-select>
           </template>

              <div class="pttti" @click="show_point(put.start_point_id)">

                <img src="/static/map.png">

              </div>


            </div>
          </div>

          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42350) }}</span>
            </div>
            <div class="ipt1 pt_box">

               <template v-if="put.source == 'highwaybus'">
						<div class="pre_city">

							<div class="tlt">
									{{get_end_tit()}}
							</div>
							<div class="icr">

							</div>

						</div>
					</template>
          <template v-if="put.source == 'bushikaku'">
 <el-select class="ipt" v-model="put.end_point_i"  >
                <el-option v-for="(pt, n) in end_points" :key="n" :label="pt.title"
                  :value="n">
                </el-option>
              </el-select>
           </template>

           <template  v-if="put.source == 'jbus'">


              <el-select class="ipt" v-model="put.end_point_id" @change="end_change">
                <el-option v-for="(pt, n) in ends" :key="n" :label="pt.tit"
                  :value="pt.id">
                </el-option>
              </el-select>

              <div class="pttti" @click="show_point(put.end_point_id)">


                <img src="/static/map.png">

                </el-button>

              </div>

           </template>
            </div>
          </div>
          <div class="stock" v-if="stock > -1">
            <div class="syyy">{{$lang(49499)}} <br />
              <span style="  color:  rgb(241, 27, 12);"> {{stock}} </span> {{$lang(49500)}}
            </div>

          </div>


        </div>




        <div class="notes" v-if="info.man_price != info.children_price">
          <div class="text3">
            <span> {{ $lang(42354) }}

            </span>
          </div>

        </div>

        <div class="people_info">
          <!-- 乘客基本信息 -->
          <div class="tit5">
            <span>{{ $lang(42355) }} </span>
          </div>

          <table class="put_user_list">
            <tr>
              <td style="width:16vw;">{{ $lang(42357) }}</td>
              <td style="width:16vw;"> {{ $lang(42356) }} </td>
              <td style="width:16vw;"> <span>{{ $lang(42360) }} / {{ $lang(42361) }} </span> </td>
              <td style="width:8vw;">
                {{ $lang(42493) }}

              </td>
            </tr>

            <tr v-for="(itm, i) in put.contacts " :key="i">
              <td class="tr_bot">
                <el-input v-model="put.contacts[i].name" :placeholder="$lang(42362)"></el-input>
              </td>
              <td class="tr_bot">
                <el-radio-group v-model="put.contacts[i].sex">

                    <el-radio class="ipt4" :label="1" > {{ $lang(42358) }}</el-radio>

                  <el-radio class="ipt4" :label="0"> {{ $lang(42359) }}</el-radio>
                </el-radio-group>
              </td>
              <td class="tr_bot">
                <el-input type="number" @change="age_change" max="120" min="0" v-model="put.contacts[i].age"
                  :placeholder="$lang(42363)">
                </el-input>

              </td>
              <td class="tr_bot  tr_botr">
                <span v-if="wait"> <i class="el-icon-loading"></i> {{$lang(50975)}}</span>
                <span v-else>{{itm.price}} {{ $lang(42374) }}</span>

                <el-button class="decc" size="mini" type="danger" icon="el-icon-delete" circle @click="del_contacts(i)">
                </el-button>

              </td>
            </tr>

            <tr>
              <!-- <td colspan="4"> </td>
              <td> </td>
              <td> </td> -->
              <td colspan="4" class="ddz222 ">
                <el-button type="success" class="add_ac_btn" size="mini" icon="el-icon-plus" @click="add_contacts">
                  {{$lang(50030)}}
                </el-button>





              </td>
            </tr>

          </table>
          <div class="contacts_boot">
          </div>

        </div>

        <!--  -->

        <!--  -->


        <!-- 联系 -->
        <div class="contact">
          <div class="sele1">
            <div class="y3">
              <div class="tit4">
                <span> <a style="color:red">*</a> {{ $lang(42366) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.mail" :placeholder="$lang(42367)"
                  :readonly="Boolean(put.mail_status)"></el-input>
              </div>
            </div>

            <div class="y3">
              <div class="tit4">
                <span> {{ $lang(42364) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.tel" :placeholder="$lang(42365)"></el-input>
              </div>
            </div>

            <div class="y3">
              <div class="tit4">
                <span> {{ $lang(42368) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.wx_num" :placeholder="$lang(42369)"></el-input>
              </div>
            </div>

          </div>
          <div class="notes">
            <div class="text3">
              <span> {{ $lang(42370) }} </span>
            </div>
          </div>

        </div>





        <div class="up_down">

          <div class="btn" @click="smbt()">

            <span v-if="wait"> <i class="el-icon-loading"></i> {{ $lang(50975) }}</span>
            <span v-else> {{ to_price(total_price) }}
              {{ $lang(42374) }} </span>

            <span class="bababax">{{ $lang(42373) }} </span>
          </div>
        </div>
      </div>
    </div>

    <point_tc :id="point_id" ref="pot_tc"> </point_tc>


  </div>
</template>

<script>
import nav_list from '../index/nav_list.vue';
import langMixin from "../../utils/lang.js";
export default {
  name: "personal_info",
  mixins: [langMixin],
  components: {  //注册
    nav_list,
  },
  data() {
    let r = []

    // for (let i = 0; i < 50; i++) {
    //   r.push({
    //     name: '',
    //     sex: -1,
    //     age: '',
    //     price: 30,
    //   })
    // }
    // console.log(r)
    return {



      show: false,
				index: -1,

				cp_info: '',
				thumb: '',
				refund_plan: '',

				timer: 60,
				vd_time: 0,
				id: 0,
				vo:{},
				info: {
					trainv: {
						use_spd_price: 0,
					}
				},
				conf : {},
				contacts: r,
				stock: -1,
				man_price: 0,
				children_price: 0,
				org_man_price: 0,
				org_children_price: 0,
				wait: 0,
				put: {
					source_id: 0,
					end_point_id: null,
					start_point_i: null,
					start_point_id: null,
					end_point_i: null,
					end_point_id: 0,
					contacts: [{
						name: '',
						sex: -1,
						age: '',
						price: 0,
					}],
					total_price: 0,
					train_realtime_id: 0,
					train_price_id: 0,
					tel: '',
					mail: '',
					wx_num: '',
					is_allowed: '',
					source : '',
					date : '',

				},
        info : {},
				p2p: [],
				start_points: [],
				end_points: [],
				starts: [],
				ends: [],
				point_id: 0,
				text_show: false,
				is_allowed: true,
				rate : 1,// 汇率
        total_price : 0,
    };
  },
  mounted() {

    this.f5()
    document.title = this.web_tit;
    this.put.source = 	this.cache('hot_source')

			 this.vo = this.cache('hot_vo')
			 console.log('this.vo', this.vo)
			 this.put.date = this.vo.start_date || this.vo.date
			 if (this.put.source == 'jbus') {
				 this.vo['start_tit'] = ''
				 this.vo['end_tit'] = ''
				 this.vo['start_time'] = ''
				 this.vo['end_time'] = ''
				 
          this.get_j_start_end()
          this.push_hot_jbus(this.vo)
				  this.get_cn()
			 } else if (this.put.source == 'highwaybus') {
				 this.vo['start_time'] = this.vo['start_time'].replaceAll(' 発', '')
				 this.vo['end_time'] = this.vo['end_time'].replaceAll('着', '')
				 this.vo['end_tit'] = this.vo['end_tit'] 
				 this.vo['start_tit'] = this.vo['start_tit']  
				 this.man_price = this.vo.price
				 this.children_price = this.vo.price
				 // this.put['org_price'] = this.vo.org_price
				 // this.put['price'] = this.vo.price
         this.push_hot_highwaybus_jp(this.vo)
				this.get_cn()
			 } else {
           
          this.push_v4_pre_jp(this.vo)
          this.get_cn()
          console.log('info',this.vo)
          this.start_points = this.vo.platforms.filter(p => p.platform_type === 'geton')
          this.end_points = this.vo.platforms.filter(p => p.platform_type === 'getout')
          this.man_price =  this.vo.man_money
          this.children_price =  this.vo.child_money
 
       }
  },
  methods: {
    lang_after(){
    
      if (this.put.source == 'jbus') {
					 
           let start_wz = [...this.vo.starts]
           console.log('start_wz', start_wz)
          
            
          
           for (let vo of start_wz) {
             vo.tit= this.tt(vo.tit)
           }
           this.vo.starts = start_wz
           this.starts = start_wz
 
           let end_wz = [...this.vo.ends]
            
           for (let vo of end_wz) {
             vo.tit= this.tt(vo.tit)
           }
           this.vo.ends = end_wz
           this.ends = end_wz
             
         }  else {
          for (let vo of this.end_points) {
            vo.title = this.tt(vo.name)
          }
          for (let vo of this.start_points) {
            vo.title = this.tt(vo.name)
          }
         }
		
        
        
			},
    to_price(v){
				if(!v ) return 0
				if (this.cur_lang() == 'jp') {
					return v;
				}
				return (parseFloat(v) / this.rate).toFixed(2)
			},
			get_j_start_end(){
				// https://secure.j-bus.co.jp/hon/BusService?
				// wayflg=0&gpcd=150041&rocd=0001&dtym[0]=202412&dtdd[0]=27&bncd[0]=0101&bscd[0]=01&dscd[0]=00&remainingseats[0]=18&sdis=0&pdis=3
				// data-gpcd = 150041
				// rocd = 0001
				// data-bncd
				let v = this.vo
				let url = `https://yichen.geslan.cn/jbus/hon/BusService?wayflg=0&gpcd=${v.gpcd}&rocd=${v.rocd}&dtym[0]=202412&dtdd[0]=27&bncd[0]=${v.bncd}&bscd[0]=${v.bscd}&dscd[0]=${v.dscd}&remainingseats[0]=${v.seat}&sdis=${v.discount_student}&pdis=${v.discount_disabilities}`
				console.log(url)

			},
			get_start_tit(){
				if (this.put.source == 'highwaybus') {
					return this.tt(this.vo.start_tit)
				}
				for (let vo of  this.vo.starts) {
					if (vo.id == this.put.start_point_id) {
						return vo.title
					}
				}
				return '请选择'
			},
			get_end_tit(){
				if (this.put.source == 'highwaybus') {
					return this.tt(this.vo.end_tit)
				}
				for (let vo of  this.vo.ends) {
					if (vo.id == this.put.end_point_id) {
						return vo.title
					}
				}
				return '请选择'
			},
			start_change(e) {
        console.log(e)

				this.put.start_point_id = e
        this.vo['start_tit'] = this.starts.find(item => item.id === e).title
        this.vo['start_time'] = this.vo.starts.find(item => item.id === e).time

				this.get_price()
				this.$forceUpdate()
			},
			end_change(e) {
				// console.log(e)
				this.put.end_point_id = e

        this.vo['end_tit'] = this.vo.ends.find(item => item.id === e).title
        this.vo['end_time'] = this.vo.ends.find(item => item.id === e).time

				this.$forceUpdate()
				this.get_price()
			},
			get_price(){
				if (!this.put.end_point_id  || !this.put.start_point_id ) {
					return 0
				}


				/*

				GroupCode: 150041
				RouteCode: 0001
				WayFlag: 片道
				MoveCode[0]: 0101
				BusCode[0]: 01
				Departure[0]: 2024/12/27
				PlanCode[0]: 00
				GetOnBusStopCode[0]: 21
				GetOffBusStopCode[0]: 17
				*/
			   let v = this.vo
				let data = {
					GroupCode : v.gpcd,
					RouteCode : v.rocd,
					WayFlag : '片道',
					MoveCode : v.bncd,
					BusCode : v.bscd,
					Departure : this.put.date.replaceAll('-', '/'),
					PlanCode : '00',
					GetOnBusStopCode : this.put.start_point_id,
					GetOffBusStopCode : this.put.end_point_id
				}
				let url = 'https://yichen.geslan.cn/jbus/hon/BusService/GetBusDivisionFare'
        	// uni.request({
				// 	url:url,
				// 	method:'GET',
				// 	data:data,
				// 	success : (e) => {
				// 		console.log('dada',e)
				// 		this.man_price = e.data[0].price * this.conf.inc_rate
				// 		this.children_price = e.data[1].price * this.conf.inc_rate
				// 		this.org_man_price = e.data[0].price
				// 		this.org_children_price = e.data[1].price
				// 		this.vo['org_price'] = e.data[0].price
				// 		this.vo['price'] = this.man_price

				// 	}
				// })

        this.$axios.get(url, { params: data })
        .then((e) => {
          console.log('dada', e);
          this.man_price = e.data[0].price * this.conf.inc_rate;
          this.children_price = e.data[1].price * this.conf.inc_rate;
          this.org_man_price = e.data[0].price;
          this.org_children_price = e.data[1].price;
          this.vo['org_price'] = e.data[0].price;
          this.vo['price'] = this.man_price;
        })
        .catch((error) => {
          console.error('请求出错:', error);
        });

			},
			run_djs() {
				if (this.timer <= 0) {
					return this.get_new_info()

				}
				this.timer--

				setTimeout(() => {
					this.run_djs()
				}, 1000);
			},
			show_timer() {

				let m = parseInt((this.timer / 60))
				let s = this.timer % 60
				if (m < 10) {
					m = '0' + m
				}
				if (s < 10) {
					s = '0' + s
				}
				return m + ':' + s

			},
			show_point(id) {
				// alert(id)
				this.point_id = id
				this.$refs.pot_tc.f5(id)
			},
			add_contacts() {
				if (this.stock > -1 && this.put.contacts.length >= this.stock) {
					return this.$message(this.c(49501));

				}
				this.put.contacts.push({
					name: '',
					sex: -1,
					age: '',
					price: 0,
				})
				this.update_contacts_price()
			},
			update_contacts_price() {
				this.total_price = 0
				for (let i in this.put.contacts) {
					if ((!this.put.contacts[i].age || this.put.contacts[i].age <= 0) || this.put.contacts[i].age > 11) {
						this.put.contacts[i].price = this.man_price

					} else {
						this.put.contacts[i].price = this.children_price
					}
					this.total_price += this.put.contacts[i].price
					this.put.contacts[i].price = this.to_price(this.put.contacts[i].price)

				}
				this.total_price = this.decimal(this.total_price)
			},
			age_change(value) {
				this.update_contacts_price()

			},
			del_contacts(i) {
				this.put.contacts.splice(i, 1)
				this.update_contacts_price()
			},
			smbt() {
				if (this.stock > -1 && this.put.contacts.length >= this.stock) {
					return this.$message(this.c(49501));

				}
				for (let i in this.put.contacts) {
					if (this.put.contacts[i].sex == -1) {

						return this.$message(this.c('42355') + (i + 1) + '' + this.c(50031));
					}
					if (!this.put.contacts[i].name) {

						return this.$message(this.c('42355') + (i + 1) + '' + this.c(50033));
					}
					if (!this.put.contacts[i].age) {

						return this.$message(this.c('42355') + (i + 1) + '' + this.c(50032));
					}
				}
				this.put['is_allowed'] = this.is_allowed ? 1 : 0
				this.cache('mpput_' + this.id, this.put)


				this.put['source_data'] = this.vo

				this.put['total_price'] = this.to_price( this.total_price)
				this.put['jp_amount'] =  this.total_price
        if (this.put.source == 'bushikaku') {
          if (this.put.start_point_i === null) {
					  return this.$message('请选择出发站点');
          }
          if (this.put.end_point_i === null ) {
            return this.$message('请选择目的站点');
          }
          this.vo['stats'] = this.start_points
          this.vo['ends'] = this.end_points
          this.vo['start_point_i'] = this.put.start_point_i
          this.vo['end_point_i'] = this.put.end_point_i
          this.vo['stat_tit'] = this.start_points[this.put.start_point_i].name
          this.vo['end_tit'] = this.end_points[this.put.end_point_i].name
        }
       
        let url = '/hot/create_order'
        if (this.put.source == 'bushikaku') {
          url = '/v4/create_order'
        }
        // console.log('url', this.put['source_data'] )
        // return
				this.get(url, this.put, 'post').then((e) => {
					if (e.token) {

						this.cache('info', e.info);
						this.cache('token', e.token);

					}
					this.cache('pre_put', '')
					this.jump('/hot/pay?sn=' + e.sn)
				});
			},
			update_man_price() {
        console.log('update_man_priceupdate_man_priceupdate_man_price')
				if (this.vo.trainv.use_spd_price == 0) {
					this.man_price = this.p2p[this.put.start_point_id][this.put.end_point_id]['man_price']
					this.stock = this.p2p[this.put.start_point_id][this.put.end_point_id]['stock']
					this.children_price = this.p2p[this.put.start_point_id][this.put.end_point_id]['children_price']
					this.update_contacts_price()
				}

			},

			f5() {
				this.get("/hot/uinfo", {
					id : this.cache('hot_id')
				}).then((e) => {
					this.conf = e.conf
					this.rate = e.rate
					if (e.user) {
						this.put.tel = e.user.tel
						this.put.mail = e.user.mail
						this.put.wx_num = e.user.wx_num

						this.put.mail_status = Boolean(e.user.mail)

					}
				});
			},
			set_allowed() {
				this.is_allowed = true
			},
			set_not_allowed() {
				this.is_allowed = false
			}
  }
}
</script>

<style scoped>
.djs {
  position: fixed;
  z-index: 2;
  width :200px;
  min-height: 40px;
  background: #fff;
  left: 3%;
  bottom: 12%;
  border: 1px solid #F49847;
  border-radius: 5px;
  align-items: center;
  text-align: center;
  padding: 10px 0;

}
._dtit {
  color: #F49847;
  font-size: 13px;
}
._dtimer {
  font-size: 25px;
}
.pt_box {
  display: flex;
  align-items: center;
}

.pttti {
display: none;
  margin-left: 4px;
}
.pttti img {
  width: 100%;
}

.contacts_boot {
  display: flex;
  justify-content: end;
  padding-right: 46px;
  margin-top: 10px;
  margin-bottom: 10px;
}


.put_user_list {
  border-spacing: 0px
}

.put_user_list td {
  padding: 10px;
  text-align: center;
  font-size: 13px;
  height: 40px;
}

.tr_bot {
  border-bottom: 1px solid #eee;
}

.tr_botr {
  text-align: right !important;
  padding-right: 50px !important;
}

.ddz222 {
  text-align: center;
}

decc {
  -left: 10px;
}
</style>
<style scoped>

.per {
  display: flex;
  margin-top: 2%;

}

/* 详细信息 */
.t1 {
  margin-left: 14%;
  width: 330px;
  height: 85vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);

  border-radius: 10px;
}

.t1 .tit1 {
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: rgb(4, 100, 221);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  text-align: center;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 400;
}

.t1 .tit1 .info {
  display: flex;
  margin: 0 auto;
  width: 72px;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0%;
}

.t1 .tit1 .info span {
  margin-top: 19%;
}

.t1 .img1 img {
  width: 330px;
  height: 191px;
}

.t1 .img1 img {
  width: 330px;
  height: 191px;
}

.t1 .train {
  display: flex;
  width: 100%;
  margin-bottom: 3%;
}

.t1 .train .tit2 {
  margin-right: 4%;
  margin-left: 6%;
  margin-top: 2%;
  color: rgb(4, 100, 221);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0%;
  text-align: center;
   white-space: nowrap;
}

.t1 .train .con1 {
  margin-right: 2%;
  margin-top: 2%;
  color: rgb(33, 37, 41);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0%;


}

.t1 .txt1 {

  width: 100%;
  background: rgb(249, 250, 254);
  border-radius: 5px;
  width: 90%;
  padding: 5px;
  margin: auto;
  margin-bottom: 10%;
}

.t1 .txt1 .text1 {
  margin-left: 6%;
  margin-right: 6%;
  margin-top: 3%;
  margin-bottom: 3%;
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0%;
  text-align: left;
}

.t2 {
  display: flex;
  flex-direction: column;
  margin-left: 2%;
}

.t2 .step1 {
  width: 58vw;
  height: 14vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
}

.t2 .step1 .con1 {
  flex: 0 0 33%;
  display: flex;
}

.t2 .step1 .con1 img {
  margin-left: 15%;
  margin-right: 5%;
  margin-top: 12%;
  width: 30px;
  height: 30px;
}

.t2 .step1 .con1 .y1 {
  margin-top: 12%;
}

.t2 .step1 .con1 .y1 .u1 {
  color: rgb(29, 33, 41);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
  font-weight: bold;
}

.t2 .step1 .con1 .y1 .u2 {
  color: rgb(134, 144, 156);
  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
}

.t2 .channel {
  margin-top: 1%;
  display: flex;
  flex-direction: column;
  width: 58vw;
  min-height: 25vh;
  box-sizing: border-box;
  padding: 20px 0px;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
}

.t2 .screen {
  margin-top: 2%;
  display: flex;
}

.t2 .channel .screen .block1 {
  background-color: rgb(249, 250, 254);
  color: #000;
  margin-left: 2%;

  height: 35px;
  line-height: 30px;

  display: flex;
  border-radius: 4px;
  padding: 0 10px;
    border-radius: 5px;
    background-color: rgba(239, 239, 239, 1);
    color: #6C6C6C;
    text-align: center;
}

.t2 .channel .screen .block1 .y2 {
  margin: 0 auto;
}

.t2 .channel .screen .block1 img {
  width: 18px;
  height: 18px;

}

.t2 .channel .screen .block1 span {

  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0%;
}

.t2 .channel .lef {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 3%;
  margin-left: 2%;
}

.t2 .channel .lef .lis_tab {
  text-align: center;
  border-spacing: 0px;
}

.t2 .channel .lef .lis_tab .tit3 {
  color: rgb(4, 100, 221);
}

.t2 .sele1 {
  margin-top: 1%;
  width: 58vw;
  height: 15vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
}

.t2 .sele1 .y3 {
  flex: 0 0 25%;
  margin-top: 3%;
  margin-left: 3%;
}

.t2 .sele1 .stock {
  flex: 0 0 10%;
  margin-left: 3%;
  height: 15vh;
  align-items: center;

  font-weight: bold;

}

.t2 .sele1 .syyy {

  margin-top: 5.5vh;
  ;


}

.t2 .sele1 .y3 .tit4 span {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  text-align: center;

}

.t2 .sele1 .y3 .ipt1 {
  margin-top: 2%;
}

.t2 .sele1 .y3 .ipt1 .ipt {
  width: 15vw;
}

.t2 .people_sele {
  margin-top: 1%;
  width: 58vw;
  height: 14vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
}

.t2 .people_sele .y4 {
  margin-left: 3%;
  margin-top: 3%;
  flex: 0 0 40%;
}

.t2 .people_sele .y4 .tit4 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
}

.t2 .people_sele .y4 .ipt2 {
  margin-top: 2%;
}

.t2 .people_sele .y4 .ipt2 .sub_tit {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-right: 5%;
}

.t2 .people_sele .y4 .ipt2 .xh {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0%;
  margin-right: 5%;
  margin-left: 5%;
}

.t2 .notes {

  width: 58vw;

  box-sizing: border-box;


}

.t2 .notes .text3 {
  margin-top: 1%;
  line-height: 30px;
  min-height: 30px;

  border-radius: 10px;
  align-items: center;
background-color: rgba(0, 0, 0, 0.05);
    color: rgba(16, 16, 16, 0.9);
  padding: 10px;


}


.t2 .people_info {
  width: 58vw;
  margin-top: 1%;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.t2 .people_info .r1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2%;
}

.t2 .people_info .tit5 {
  margin-top: 2%;
  margin-left: 18px;
  color: rgb(33, 37, 41);
  font-family: Noto Sans SC;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: 0%;
  border-bottom: 1px solid #eee;
}

.t2 .people_info .r1 .info2 {
  width: 100%;
  display: flex;
}

.t2 .people_info .r1 .info2 .block3 {
  flex: 0 0 25%;
  align-items: center;

}

.t2 .people_info .r1 .btnn {
  flex: 0 0 5%;

  height: 73px;
  line-height: 100px;
  align-items: center;
}

.t2 .people_info .r1 .info2 .block3 .sub_tit2 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-top: 2%;
  margin-left: 7%;

}

.t2 .people_info .r1 .block3 .ipt3 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  height: 40px;
  letter-spacing: 0%;
  margin-top: 2%;
  margin-left: 7%;

}

.t2 .people_info .r1 .block3 .ipt3 .ss {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-left: 3%;
  margin-top: 2%;

}

.t2 .people_info .r1 .block3 .ipt3 .iptpricex {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-left: 3%;


}

.t2 .people_info .r1 .block3 .ipt3 .ipt4 {
  width: 20%;
  margin-top: 4%;
}


.t2 .total_amount {
  width: 58vw;
  height: 8.5vh;
  margin-top: 1%;
  box-sizing: border-box;
  background: rgb(255, 247, 237);
  border: 1px solid rgb(247, 175, 72);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.t2 .total_amount .text4 {
  color: rgb(208, 126, 9);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
}

.t2 .total_amount .total {
  color: rgb(255, 121, 0);
  font-family: Noto Sans SC;
  font-size: 28px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0%;
  margin-right: 5%;
}

.t2 .up_down {
    margin: 10px 0;
    border-radius: 10px;
    background-color: rgba(0, 166, 250, 1);
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
    text-align: center;
    padding: 10px 20px;
    color: #fff;
    cursor: pointer;
}



.t2 .up_down  .bababax {
   margin-left: 30px;
}

.ponts {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.bl {
  padding: 10px 10px;
  box-sizing: border-box;
  background: #E8F3FF;
  border-radius: 5px;
  color: #175EFF;
  margin-right: 10px;
  font-size: 14px;

}

.yel {

  background: #FFF7E9;
  color: #FE7D00;
}

.add_ac_btn {


    border-radius: 10px;
    background-color: rgba(80, 162, 248, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    text-align: center;
    border: 0px;
    box-shadow: 0px 2px 6px 0px rgba(57, 90, 246, 0.5);

}

.ddz222 {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/hot/pre_order.vue